module.exports = __webpack_public_path__ + "loginbgdsk.62f3289da2caa8cd9fa2.jpg";


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/assets/img/loginbgdsk.jpg
// module id = ../../../../../src/assets/img/loginbgdsk.jpg
// module chunks = styles